// extracted by mini-css-extract-plugin
export default {"main":"MainScreen_main__eS34F","head":"MainScreen_head__SULrA","headButton":"MainScreen_headButton__CH3kN","body":"MainScreen_body__zALjR","footer":"MainScreen_footer__7Wyng"};